import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NavigationComponent } from './shared/navigation/navigation.component';
import { TelemetryService } from './core/services/telemetry.service';
import { RuntimeConfigService } from './core/services/runtime-config.service';
import { getOtlpEndpoint } from './core/config/config-helpers';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, NavigationComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'Flopstr';
  private telemetryService = inject(TelemetryService);
  private runtimeConfig = inject(RuntimeConfigService);

  ngOnInit(): void {
    // Initialize OpenTelemetry for browser tracing
    // Use runtime config OTLP endpoint if available, otherwise fall back to environment
    this.telemetryService.initialize(getOtlpEndpoint(this.runtimeConfig));
  }

  ngOnDestroy(): void {
    // Shutdown telemetry when app is destroyed
    this.telemetryService.shutdown();
  }
}
